import { createSelector } from 'reselect';
import SaintPierreEtMiquelonSummaryColumns from '../../containers/SaintPierreEtMiquelonSummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.SAINT_PIERRE_ET_MIQUELON_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.SAINT_PIERRE_ET_MIQUELON_SUMMARY.isLoading;

export const getData =
  ReportDefinitions.SAINT_PIERRE_ET_MIQUELON_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, SaintPierreEtMiquelonSummaryColumns);
